module.exports = __webpack_public_path__ + "media/images/squadBet__iconChange-6abd93e936c88a3ec307829b802420e2.png";